// extracted by mini-css-extract-plugin
module.exports = {"modal":"SaveStatus-modal--3HNpb","modal-wrapper":"SaveStatus-modal-wrapper--2zyU8","save-errors":"SaveStatus-save-errors--3mLTR"};